import React, { useState, useContext, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import {
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
  FormGroup,
  Button,
} from 'reactstrap';
import cogoToast from 'cogo-toast';
import MainTable from '../../../components/tables/MainTable';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import { InfoMovesContext } from '../InfoMovesContext';
import { refFormat } from '../../../helpers/tableFormatters';
import { currencyFormat } from '../../../helpers/tableFormatters';
import { formatDate } from '../../../helpers/dateFormatters';
import ExampleCustomInput from '../../../components/input/ExampleCustomInput'
import WizardInput from '../../../components/auth/wizard/WizardInput';
import { EnvironmentContext } from '../../../context/Context';
import { informesServices } from '../../../services';
import { dateConceptFormatter, clientFormatter } from './MoveCaja';
import ExcelExport from '../../../components/excel/ExcelExport';
import PdfExport from '../../../components/pdf/table/export/PdfExport';
import ButtonIcon from '../../../components/common/ButtonIcon';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { authSesion } from "../../../helpers/authSesion";
import { urlApi } from '../../../configuracion/serverConfig';

export const headers = [
  { label: "Movimiento", key: "movimiento", type: "string" },
  { label: "Fecha", key: "fecha", type: "string" },
  { label: "Concepto", key: "nombreConcepto", type: "string" },
  { label: "Identificación", key: "identificacionTercero", type: "string" },
  { label: "Tercero", key: "nombreTercero", type: "string" },
  { label: "Débito", key: "debito", type: "money" },
  { label: "Crédito", key: "credito", type: "money" },
];

const MoveBank = () => {
  const pageSize = 25;
  const context = useContext(InfoMovesContext);
  const environment = useContext(EnvironmentContext);
  const { loading, bankMoves, handleBankSubmit, handleLoading } = context;

  /* Pagination control */
  const [totalData, setTotalData] = useState();
  const [listDataPag, setListDataPag] = useState({});
  const [pagesLoaded, setPagesLoaded] = useState([1]);

  /* Fields */
  const [listBanks, setListBanks] = useState([]);
  const [bankSelected, setBankSelected] = useState();
  const [dateRange, setDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - 8)), new Date()]);
  const [parsedDateRange, setParsedDateRange] = useState();
  const [startDate, endDate] = dateRange;


  useEffect(() => {
    if (!environment) return;
    parseBanks();
  }, [environment])

  useEffect(() => {
    if (!dateRange || !handleDateRange) return;
    handleDateRange(dateRange);
  }, dateRange)

  const columns = [
    {
      dataField: 'movimiento',
      text: 'Movimiento',
      headerClasses: 'border-0',
      align: 'left',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      //formatter: (dataField) => refFormat(dataField),
      formatter: (dataField, row) => (row.modalidad == 1 ? row.debito ? "RC-" : "CE-" : "BC-") + dataField//refFormat(dataField),
    },
    {
      dataField: 'fecha',
      text: 'Fecha / Concepto',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (dataField, selected) => dateConceptFormatter(dataField, selected),
      sort: true
    },
    {
      dataField: 'nombreTercero',
      text: 'Tercero',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      formatter: (dataField, selected) => clientFormatter(dataField, selected),
      sort: true
    },
    {
      dataField: 'pagaduria',
      text: 'Entidad pagadora',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true
    },
    {
      dataField: 'tesoreria',
      text: 'Banco',
      headerClasses: 'border-0',
      classes: 'border-0 py-2 align-middle',
      sort: true
    },
    {
      dataField: 'debito',
      text: 'Débito',
      headerClasses: 'border-0 text-right',
      align: 'right',
      classes: 'border-0 py-2 align-middle',
      sort: true,
      formatter: (value) => currencyFormat(value),
    },
    {
      dataField: 'credito',
      text: 'Crédito',
      headerClasses: 'border-0 text-right pr-3',
      align: 'right',
      classes: 'border-0 py-2 align-middle pr-3',
      sort: true,
      formatter: (value) => currencyFormat(value),
    }
  ];

  const parseBanks = () => {
    if (!environment.bankAccounts) return;
    const tempListBanks = environment.bankAccounts.map(bank => ({
      value: bank.idCuenta,
      label: `${bank.nroCuenta}-${bank.nombreBanco}`
    }));

    setListBanks(tempListBanks);
  };

  const handleDateRange = (dates) => {
    if (!dates[0] || !dates[1]) return;
    const range = [];
    range[0] = dates[0] ? formatDate(dates[0]) : "";
    range[1] = dates[1] ? formatDate(dates[1]) : "";
    setParsedDateRange(range);
  }

  const onChangeBank = data => {
    if (!environment || !environment.bankAccounts) return;
    if (!data || !data.value) {
      setBankSelected(null)
      return;
    }
    const bankIndex = environment.bankAccounts.findIndex(p => p.idCuenta == data.value);
    setBankSelected(environment.bankAccounts[bankIndex])
  }

  const onSubmit = async () => {
    setPagesLoaded([1]);
    if (/*!bankSelected ||*/ !parsedDateRange) {
      cogoToast.warn("Por favor completar los campos faltantes para la busqueda",
        { position: 'bottom-left', heading: 'Campos requeridos' });
      return;
    }

    const idBank = bankSelected?.idCuenta || 0;
    const startDate = parsedDateRange[0]
    const endDate = parsedDateRange[1]

    const response = await informesServices.getBankMoves({ startDate, endDate, idBank, page: 1, size: pageSize });
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logró completar la operación",
        { position: 'bottom-left', heading: 'Error al cargar los movimientos' });
      handleBankSubmit([])
      return;
    }

    const { filas } = response.metadata || { filas: pageSize }
    setTotalData(filas);
    handleBankSubmit(response.objResponse)
    const tempListDataPag = {};
    tempListDataPag['1'] = response.objResponse;
    setListDataPag(tempListDataPag);
  }

  const handlePagination = async page => {
    if (pagesLoaded.includes(page) || bankMoves.length < pageSize) return;
    handleLoading(true);
    setPagesLoaded([...pagesLoaded, page]);

    const idBank = bankSelected?.idCuenta || 0;
    const startDate = parsedDateRange[0]
    const endDate = parsedDateRange[1]

    const response = await informesServices.getBankMoves({ startDate, endDate, idBank, page, size: pageSize });
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logró completar la operación",
        { position: 'bottom-left', heading: 'Error al cargar los movimientos' });
      handleBankSubmit([])
      handleLoading(false);
      return;
    }

    const temp = [];
    const tempListDataPag = listDataPag;
    tempListDataPag[String(page)] = response.objResponse;

    const maxPageLoaded = [...pagesLoaded, page].sort((a, b) => b - a)[0];
    Array.from({ length: maxPageLoaded }, (_, i) => i + 1).map(p => {

      if (tempListDataPag[String(p)]) {
        temp.push(...tempListDataPag[String(p)])
      } else {
        temp.push(...Array.from({ length: pageSize }, (_, i) => ""))
      }
    })
    handleBankSubmit(temp);
    setListDataPag(tempListDataPag);
    handleLoading(false);
  }

  const getExportData = (todo) => {
    //return new Promise(async (resolve, reject) => {
    if (!bankMoves || !bankMoves[0] /*|| !bankSelected*/) {
      cogoToast.warn("No existen datos a exportar", { position: 'bottom-left', heading: 'Sin Datos' });
      return;
    }
    if (todo == 1) {
      if (!bankMoves.find(m => m.debito > 0)) {
        cogoToast.warn("No existen ingresos a exportar", { position: 'bottom-left', heading: 'Sin Datos' });
        return;
      }
    } else {
      if (!bankMoves.find(m => m.credito > 0)) {
        cogoToast.warn("No existen egresos a exportar", { position: 'bottom-left', heading: 'Sin Datos' });
        return;
      }
    }

    const idBank = bankSelected?.idCuenta || 0;
    const startDate = parsedDateRange[0]
    const endDate = parsedDateRange[1]
    const sesionToken = authSesion();
    window.open(`${urlApi}/recaudo/mov/banco/excel/${sesionToken}/${idBank}/${startDate}/${endDate}/${todo}`, "_blank");
    /*const response = await informesServices.getBankMoves({startDate, endDate, idBank});
    if (!response || response.error) {
      cogoToast.error(response?.msg || "No se logró completar la operación",
        { position: 'bottom-left', heading: 'Error al cargar los movimientos' });
      reject(false);
      return;
    }*/

    //resolve(response.objResponse);
    //})
  }

  return (
    <>
      <Card className={`my-3`} >
        <CardBody className="bg-light border-top px-4">
          <Row>
            <Col lg={3} className="mx-2">
              <DetailRow title="Rango de Fechas">
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selectsRange={true}
                  locale="es"
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  customInput={<ExampleCustomInput />}
                />
              </DetailRow>

            </Col>
            <Col lg={3} className="mx-2">
              <DetailRow title="Banco">
                <FormGroup>
                  <WizardInput
                    className="pl-2"
                    type="select"
                    tag={CustomInput}
                    value={bankSelected ? bankSelected.id : ''}
                    placeholder="Todas"
                    id="bank"
                    name="bank"
                    options={listBanks}
                    onChange={(e) => onChangeBank({ name: 'bank', value: e.target.value })}
                    errors={[]}
                  />
                </FormGroup>
              </DetailRow>
            </Col>
            <Col lg={1} className="mx-2">
              <DetailRow title="-">
                <Button onClick={onSubmit} transform="shrink-3 down-2" color="primary" >
                  Buscar
                </Button>
              </DetailRow>
            </Col>
            <Col lg={4} className="mx-2">
              <DetailRow title="Exportar">
                <Button onClick={() => getExportData(1)} transform="shrink-3 down-2" className="mr-2 mb-2">
                  Ingresos
                </Button>
                <Button onClick={() => getExportData(2)} transform="shrink-3 down-2" className="mr-2 mb-2">
                  Egresos
                </Button>
              </DetailRow>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <MainTable
        title="Movimientos"
        data={bankMoves}
        totalData={totalData}
        pageSize={pageSize}
        columns={columns}
        handlePagination={handlePagination}
        keyField="id"
        className="px-2"
        loading={loading}
        noSearch
        noAdd
        customPagination
      />
    </>
  )
}

export default MoveBank